import { Dialog as BaseDialog, type DialogPopupProps } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { backdropStyle, popupStyle } from './Dialog.css';

type Props = DialogPopupProps;

export const DialogBody = ({ children, ...delegated }: Props) => {
  return (
    <BaseDialog.Portal>
      <BaseDialog.Backdrop className={backdropStyle} />

      <BaseDialog.Popup {...delegated} className={clsxs(popupStyle, delegated.className)}>
        {children}
      </BaseDialog.Popup>
    </BaseDialog.Portal>
  );
};
